 // ErrorBoundary.js
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error
    console.error("React Error Boundary caught an error:", error, errorInfo);
    
    // If it's a DOM removeChild error, attempt to recover
    if (error.message && error.message.includes('removeChild') && error.message.includes('not a child')) {
      console.log("DOM removeChild error detected - attempting recovery");
      
      // Wait for a tick to let React finish its current operations
      setTimeout(() => {
        this.setState({ hasError: false, error: null });
      }, 0);
    }
  }

  render() {
    if (this.state.hasError) {
      // If it's a DOM removeChild error, show minimal error and auto-recover
      if (this.state.error && 
          this.state.error.message && 
          this.state.error.message.includes('removeChild') && 
          this.state.error.message.includes('not a child')) {
        
        return (
          <div style={{ padding: '10px' }}>
            <p>Recovering from DOM error...</p>
            {/* Recovery button as fallback */}
            <button 
              onClick={() => this.setState({ hasError: false, error: null })}
              style={{ padding: '5px 10px', marginTop: '10px' }}
            >
              Retry
            </button>
          </div>
        );
      }
      
      // For other errors, show more details
      return (
        <div style={{ padding: '20px', backgroundColor: '#f8d7da', border: '1px solid #f5c6cb', borderRadius: '4px', color: '#721c24' }}>
          <h2>Something went wrong.</h2>
          <p>{this.state.error && this.state.error.toString()}</p>
          <button 
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{ padding: '8px 16px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', marginTop: '15px' }}
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;